import React from 'react';
import StackedBarRenderer from './StackedBarRenderer';

// A grouped bar is a stacked bar laid out side-by-side rather than summed.
function GroupedBarRenderer(props) {
  return <StackedBarRenderer {...props} mode="grouped" />;
}

export default GroupedBarRenderer;
